import { IApplicationDetailsCard } from 'api/digifi/los/layout/CardsApi';
import { LayoutConfigurationEntityName } from 'enums/LayoutConfigurationEntityName';
import { LayoutConfigurationReferenceType } from 'product_modules/enums/LayoutConfigurationReferenceType';

import { createLayoutEntitiesSlice } from './createLayoutEntitiesSlice';

const {
  reducer,
  removeLayoutEntities: removeApplicationDetailsCards,
} = createLayoutEntitiesSlice<
  IApplicationDetailsCard
>({
  referenceType: LayoutConfigurationReferenceType.ApplicationForm,
  layoutConfigurationEntityName: LayoutConfigurationEntityName.Card,
});

export {
  removeApplicationDetailsCards,
};

export default reducer;
